export default { sha: '1c074ca2aa9e7bf1ffcdc690a218754c6c493865', buildNumber: 'undefined' }
